import joi from "joi";
import moment from "moment";

const constants = {

    sharedCatUOM: ["LBS", "KG", "TON"],
    catUOM: [
        "BAG",
        "BIG BAGS",
        "BOX",
        "BUNDLE",
        "CARTON",
        "CONTAINER",
        "CRATE",
        "DRUM",
        "ENGINE STAND",
        "EURO PALLET",
        "FIBREDRUMS",
        "GALLON",
        "PACKAGE",
        "PALLET",
        "PIECE",
        "ROLL",
        "SKID",
        "TOTE",
        "TUBE",
        "UNIT",
    ],
    catPriority: ["1", "0"],
};

export const schemaItem = joi.object({
    lineNo: joi.string().required().max(30),
    itemNo: joi.string().required().max(30),
    itemDescription: joi.string().required(),
    QTYOrdered: joi.alternatives().try(joi.number(), joi.string().allow('', ' ')).allow(null),
    UOM: joi.string().valid(...constants.catUOM).max(5).allow(null, ''),
    // UOM: joi.string()
    //     .max(5)
    //     .custom((value, helpers) => {
    //         if (!constants.catUOM.includes(value)) {
    //             return null; // si no está en catálogo → null
    //         }
    //         return value.toUpperCase(); // lo regresamos en mayúsculas
    //     })
    //     .allow(null, ''),
    volume: joi.alternatives().try(joi.number(), joi.string().allow('', ' ')).allow(null),
    vendorCode: joi.string().max(50).allow('', ' '),
    itemValue: joi.alternatives().try(joi.number(), joi.string().allow('', ' ')).allow(null),
    itemCurrency: joi.string().max(10).allow('', ' '),
    grossWeight: joi.alternatives().try(joi.number(), joi.string().allow('', ' ')).allow(null),
    grossWeightUOM: joi.string().valid(...constants.sharedCatUOM).max(5).allow('', ' '), // w
    netWeight: joi.alternatives().try(joi.number(), joi.string().allow('', ' ')).allow(null),
    netWeightUOM: joi.string().valid(...constants.sharedCatUOM).max(5).allow('', ' '), // w
    collection: joi.string().max(50).allow('', ' '),
    HSCode: joi.string().max(50).allow('', ' '),
    requestedCargoReady: joi.date().allow(null, ''),
    requiredAtDestination: joi.date().allow(null, ''),
    priorityItem: joi.string().valid(...constants.catPriority).allow('', ' '),
});
